module.exports = __webpack_public_path__ + "assets/what.72a9555fe9bc663e595c923352c0feca.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/what.png
 ** module id = 208
 ** module chunks = 0
 **/